import EventCollagesConfigurator from './EventCollagesConfigurator';

export default EventCollagesConfigurator;
